import {ImportingDataTypes} from "../../types";
import {createInvalidCustomerCodeSection, PreventionInvalidityCode, PreventativeAutocompleteType} from "./shared";

export const preventativeInteraction = {
    datasourceId: ImportingDataTypes.customersTerritoriesAndAccountManagers,
    sections: [
        createInvalidCustomerCodeSection('customerNo'),
        {
            sectionKey: 'invalidTerritory',
            sectionTitle: 'Invalid Territory Codes',
            invalidityCode: PreventionInvalidityCode.INVALID_TERRITORY,
            fields: [{
                key: 'territoryCode',
                label: 'Territory',
                type: PreventativeAutocompleteType.TERRITORY,
                extractValue: (o) => o?.code ?? null,
                modifyRow: (row, val) => ({...row, territoryCode: val})
            }]
        },
        {
            sectionKey: 'invalidAccountManager',
            sectionTitle: 'Invalid Account Manager Codes',
            invalidityCode: PreventionInvalidityCode.INVALID_ACCOUNT_MANAGER,
            fields: [{
                key: 'accountManagerCode',
                label: 'Account Manager',
                type: PreventativeAutocompleteType.SALES_PERSON,
                extractValue: (o) => o?.code ?? null,
                modifyRow: (row, val) => ({...row, accountManagerCode: val})
            }]
        },
        {
            sectionKey: 'missingRequiredFields',
            sectionTitle: 'Missing Required Fields',
            invalidityCode: PreventionInvalidityCode.MISSING_REQUIRED_FIELDS,
            fields: [
                {
                    key: 'customerNo',
                    type: 'text',
                    extractValue: (o) => typeof o === 'string' ? o : o?.code ?? null,
                    modifyRow: (row, val) => ({...row, customerNo: val})
                },
                {
                    key: 'territoryCode',
                    label: 'Territory',
                    type: PreventativeAutocompleteType.TERRITORY,
                    extractValue: (o) => o?.code ?? null,
                    modifyRow: (row, val) => ({...row, territoryCode: val})
                },
                {
                    key: 'accountManagerCode',
                    label: 'Account Manager',
                    type: PreventativeAutocompleteType.SALES_PERSON,
                    extractValue: (o) => o?.code ?? null,
                    modifyRow: (row, val) => ({...row, accountManagerCode: val})
                },
            ]
        }
    ],
};
